<template>
  <div>
    <div class="text-2xl font-bold text-red-800">Print Started</div>
    <div class="py-4 flex items-center space-x-4 text-red-800">
      <div class="p-1 bg-red-100 rounded-full">
        <icon name="exclamation" class="w-8 h-8" />
      </div>
      <div>
        <strong>Warning:</strong>
        Print in progress. Please try again later.
      </div>
    </div>
    <div class="flex items-center space-x-8 mt-2">
      <button @click="handle()" class="py-1 px-2 bg-red-500 text-white rounded">
        Confirm
      </button>
    </div>
  </div>
</template>

<script>
import { ModalBus } from "@/eventBus";

export default {
  name: "PrintLockedModal",
  props: {},
  data() {
    return {
      loading: false,
      error: false,
    };
  },
  components: {},
  methods: {
    handle() {
      this.$emit("onClose", true);
      ModalBus.$emit("force:backorder:refresh");
    },
  },
};
</script>
